module.exports = __webpack_public_path__ + "img/T6-C-rc_12.08833413.png";